<template>
  <a-modal
    :title="upload.title"
    :visible="excelVisible"
    @cancel="importExcelHandleCancel"
  >
    <div class="btn">
      <a-button @click="onDownloadTemplate">下载模板</a-button>
    </div>
    <a-upload-dragger
      v-if="excelVisible&&customizeUpload"
      name="file"
      :multiple="upload.multiple"
      :accept="upload.accept"
      :customRequest="customUpload"
    >
      <p class="ant-upload-drag-icon">
        <a-icon type="inbox" />
      </p>
      <p class="ant-upload-text">
        请将文件拖拽到此处上传
      </p>
      <p class="ant-upload-hint">
        {{ upload.multiple?'支持单个或批量上传，也可以点击后选择文件上传':'支持单个文件上传，可以点击后选择文件上传' }}
      </p>
    </a-upload-dragger>
    <a-upload-dragger
      v-if="excelVisible&&!customizeUpload"
      name="file"
      :multiple="upload.multiple"
      :accept="upload.accept"
      :headers="upload.headers"
      :action="upload.url"
      @change="importExcelHandleChange"
    >
      <p class="ant-upload-drag-icon">
        <a-icon type="inbox" />
      </p>
      <p class="ant-upload-text">
        请将文件拖拽到此处上传
      </p>
      <p class="ant-upload-hint">
        {{ upload.multiple?'支持单个或批量上传，也可以点击后选择文件上传':'支持单个文件上传，可以点击后选择文件上传' }}
      </p>
    </a-upload-dragger>
    <template #footer>
      <a-space>
        <a-button @click="importExcelHandleCancel">关闭</a-button>
      </a-space>
    </template>
  </a-modal>
</template>

<script>
import Cookies from 'js-cookie'
import { parseResFileOrJson } from '@/utils/request'

export default {
  name: 'ImportExcel',
  data() {
    const token = (process.env.NODE_ENV === "development" || localStorage.getItem('isFromSystemLogin') === 'true') ? localStorage.getItem('token') : Cookies.get('Admin-Token')
    const Authorization = token ? 'Bearer ' + token : undefined;
    return {
      // 用户导入参数
      upload: {
        multiple: false, // 是否支持多选文件
        accept: '.xlsx, .xls', // 允许上传的文件后缀
        open: false, // 是否显示弹出层（用户导入）
        title: '导入Excel', // 弹出层标题（用户导入）
        isUploading: false, // 是否禁用上传
        updateSupport: 0, // 是否更新已经存在的用户数据
        headers: { Authorization: Authorization }, // 设置上传的请求头部
        url: process.env.VUE_APP_API_BASE_URL + '/scp/supplierRankCategory/import' // 上传的地址
      },
      uploadSuccess: false, // 是否上传
      excelVisible: false // 导入excel
    }
  },
  props: {
    // 上传参数
    uploadParams: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 下载模板参数
    downloadParams: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 是否为自定义上传（区分请求错误的处理方式：1、多个错误信息，前端整合后展示；2、错误信息以错误文件形式下载）
    customizeUpload: {
      type: Boolean,
      default: false
    },
    // 自定义上传请求参数
    uploadAboutRequest: {
     type: Object,
      default: () => {
        return {}
      }
    }
  },
  methods: {
    // 下载模板
    onDownloadTemplate() {
      if (!this.downloadParams?.url) {
        return this.$message.error('请设置下载地址')
      }
      if (!this.downloadParams?.name) {
        return this.$message.error('请设置下载文件名')
      }
      this.$message.loading({ content: '下载中...' })
      if (this.downloadParams.method === 'post') {
        this.downloadByJson(this.downloadParams.url, {}, this.downloadParams.name)
      } else {
        const url = this.downloadParams.url;
        const link = document.createElement('a');
        link.href = url;
        link.download = this.downloadParams.name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    // 显示
    show() {
      this.uploadSuccess = false;
      if (this.uploadParams.url) {
        this.upload = { ...this.upload, ...this.uploadParams } // 如有新入参的参数，覆盖旧参数
      }
      this.excelVisible = true;
    },
    // 导入excel窗体关闭
    importExcelHandleCancel () {
      this.excelVisible = false
      this.$emit('refresh', this.uploadSuccess)
    },
     // 自定义上传，由后端处理错误信息，下载错误信息文件
      async customUpload({ file, onSuccess, onError }) {
      try {
        const formData = new FormData();
        formData.append('file', file);
        if(this.uploadAboutRequest?.requestApi) {
          this.uploadAboutRequest.requestApi(formData).then(res => {
          parseResFileOrJson(res, () => {}, this.uploadAboutRequest?.errFileName || '导入异常.xlsx');
          onSuccess({ code: 200 }, file);
        }).finally(() => {
          // this.isUploading = false;
        })
        } else {
          this.$message.warning('导入接口传参错误')
        }
      } catch (error) {
        onError(error);
      }
    },
    // 导入excel后，由前端处理错误提示展示
    importExcelHandleChange (info) {
      const status = info.file.status
      if (status !== 'uploading') {
      }
      if (status === 'done') {
        if (info?.file?.response?.code === 200) {
          this.uploadSuccess = true;
          this.$message.success(`${info.file.name}: ${info.file.response.msg}`)
        } else {
          // 处理错误信息，换行展示
          const h = this.$createElement;
          let msgContents = []
          if (info?.file?.response?.msg) {
            const msgList = info.file.response.msg.split('<br>')
            msgList.forEach(val => {
              msgContents.push(h('p', val))
            })
          }
          if (msgContents?.length < 1) { msgContents = [h('p', '导入失败')] }
          this.$error({
            title: '提示',
            content: h('div', {}, msgContents),
            okText: '确认',
            width: 500,
            onOk: () => {}
          })
        }
      } else if (status === 'error') {
        this.$message.error(`${info.file.name}: ${info.file.response.msg}`)
      }
    }
  }
}
</script>

<style lang='less' scoped>
.btn{
  margin-bottom: 20px;
}

</style>
